import React from 'react';
import { Typography } from '@fullstory/components';
import { EngagementMapsDetailsRow } from '../EngagementMapsDetailsRow';
import { PageDefinition } from '@fullstory/proto/fs/api/pages';
import { ResourceDisplayPane } from '@fullstory/library-ui';
import { getPageMetadata, getPageName, PageDefinitionBody } from '@fullstory/pages-shared';
import { FormattedMessage, useIntl } from 'react-intl';

export interface PageDefinitionRowProps {
  pageDefinition: PageDefinition;
  onPageEdit?: React.ComponentProps<typeof ResourceDisplayPane.Header>['onOpen'];
  canAccess?: React.ComponentProps<typeof ResourceDisplayPane.Header>['canAccess'];
}

export const PageDefinitionRow: React.FC<PageDefinitionRowProps> = ({
  pageDefinition,
  onPageEdit,
  canAccess,
}) => {
  const intl = useIntl();
  return (
    <EngagementMapsDetailsRow
      data-component="PageDefinitionRow"
      icon={{ name: 'pages/page-icon' }}
      label={{ body: intl.formatMessage({ defaultMessage: 'Page:', id: 'wyRVcv' }) }}
      value={{
        body: pageDefinition
          ? getPageName(pageDefinition)
          : intl.formatMessage({ defaultMessage: 'Page not found', id: 'QRccCM' }),
      }}
      tooltipContent={
        pageDefinition ? (
          <ResourceDisplayPane tooltip>
            <ResourceDisplayPane.Header
              label={getPageName(pageDefinition)}
              onOpen={onPageEdit}
              icon="page"
              canAccess={canAccess}
            />
            <ResourceDisplayPane.Body>
              <PageDefinitionBody pageDefinition={pageDefinition} />
            </ResourceDisplayPane.Body>
            <ResourceDisplayPane.Footer metadata={getPageMetadata(pageDefinition)} />
          </ResourceDisplayPane>
        ) : (
          <Typography variant="body3">
            <FormattedMessage defaultMessage="Page not found" id="QRccCM" />
          </Typography>
        )
      }
      tooltipProps={{
        disablePadding: true,
        offset: 12,
        placement: 'bottom',
        maxWidth: 400, // needs to be 400 to match ResourceDisplayPane's width
        variant: 'light',
      }}
    />
  );
};
